module.exports = __webpack_public_path__ + "static/media/webdesign-services-img10.a1b76a3e.jpg";